function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#92D3F5",
  d: "m58 25.7-11.9-4.8c-.2-4.3-1.9-11.3-10.6-11.6-12 0-14.6 11-14.6 11l-1 2-.6 1.2-5.3 2.2"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#61B2E4",
  d: "M19.086 25.7 16.8 31.4a2.54 2.54 0 0 0-.2 1.9L19.5 44a.365.365 0 0 0 .7 0l.2-7.7.6-.6 1-1.3 8-8.8"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#92D3F5",
  d: "M17 60.949v-4c0-4.994 4.641-9.335 9.633-9.335 6 5 12.998 4.917 18.998-.083 4.994 0 9.369 4.424 9.369 9.418v4"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fill: "#61B2E4",
  d: "M45.662 60.949v-4.012c-.14-2.631-1.648-5.362-3.702-7.013.995-.554 2.676-1.563 3.67-2.393 4.995 0 9.37 4.424 9.37 9.418v4m-1.632-20.41a5 5 0 1 1 4.287-.188"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fill: "#92D3F5",
  d: "M55.315 32.472a4.382 4.382 0 0 0-2.34 1.15 10.65 10.65 0 0 1 4.68 0 4.382 4.382 0 0 0-2.34-1.15z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fill: "#A57939",
  d: "M57.314 61V40.539h-4V61"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fill: "#D0CFCE",
  d: "M35.758 54.396c13.421-9.693 13.094-22.147 11.7-27.582h-1.7S47.338 34.71 36 34.71s-9.496-7.897-9.496-7.897h-1.746c-1.602 4.745-2.397 15.674 11 27.582z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  fill: "#FCEA2B",
  d: "M45.758 25.814S47.338 34.71 36 34.71s-9.496-8.897-9.496-8.897"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M19.086 25.8 16.9 31.4a2.54 2.54 0 0 0-.2 1.9L19.5 44a.365.365 0 0 0 .7 0l.2-7.7c.01-.473.077-.943.2-1.4m6.3-17.4a15.942 15.942 0 0 0-.9 3.4h0l-12 4.9h44l-11.9-4.9c-.2-4.3-2.2-11.3-10.9-11.6-13 0-15.2 13.5-15.2 13.5m33.368 17.79a5 5 0 1 1 4.287-.188m-.341 19.649V40.605h-4v19.446"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M46.44 48.109c2.707.407 5.272 1.925 6.876 4.06M17 60v-3c0-4.582 4.216-8.333 8.768-8.92"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M42 29.9c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2m-8 0c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M33 38.1c1.9 1 4.1 1 6 0"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M35.758 54.396c13.421-9.693 13.094-22.147 11.7-27.582h-1.7S47.338 34.71 36 34.71s-9.496-7.897-9.496-7.897h-1.746c-1.602 4.745-2.397 15.674 11 27.582z"
});

var SvgWizard = function SvgWizard(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 72 72",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWizard, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/wizard.112cd491.svg";
export { ForwardRef as ReactComponent };